const getters = {
  getGamepalCategory: (state) => {
    return state.categories.find((category) => category.name === 'Gamepals')
  },
}

export default getters
